module.exports = __webpack_public_path__ + "img/Path 744.889bf06e.svg";